export const toPlainErrorObject = (serverError) => {
  const errValue = serverError?.toJS ? serverError.toJS() : serverError;
  if (typeof errValue === 'string') return { message: errValue };
  if (!errValue) return { message: 'Request failed' };
  return errValue;
};

export const isConnectionErrorSentinel = (err) => {
  const message = String(err?.message || '').trim();
  const code = String(err?.code || err?.name || err?.__type || '').trim();
  return (
    message === 'CONNECTION_ERROR' ||
    code === 'CONNECTION_ERROR' ||
    message === 'CONNECTIO_ERROR' ||
    code === 'CONNECTIO_ERROR'
  );
};
